var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfoLine = function SvgInfoLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99935 18.3307C5.39697 18.3307 1.66602 14.5997 1.66602 9.9974C1.66602 5.39502 5.39697 1.66406 9.99935 1.66406C14.6017 1.66406 18.3327 5.39502 18.3327 9.9974C18.3327 14.5997 14.6017 18.3307 9.99935 18.3307ZM9.99935 16.6641C13.6813 16.6641 16.666 13.6793 16.666 9.9974C16.666 6.3155 13.6813 3.33073 9.99935 3.33073C6.31745 3.33073 3.33268 6.3155 3.33268 9.9974C3.33268 13.6793 6.31745 16.6641 9.99935 16.6641ZM9.16602 5.83073H10.8327V7.4974H9.16602V5.83073ZM9.16602 9.16406H10.8327V14.1641H9.16602V9.16406Z",
    fill: "#0E3F6C"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-line.c363ed58.svg";
export { ForwardRef as ReactComponent };